import { render, staticRenderFns } from "./SidebarNavDropdown.vue?vue&type=template&id=7bbba7c3"
import script from "./SidebarNavDropdown.vue?vue&type=script&lang=js"
export * from "./SidebarNavDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports